/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputTimeComponent = {
    template: require('./gmao-input-time.html'),
    bindings: {
        model: '=',
        validationError: '<',
        disabled: '<',
        required: '<',
        placeholderKey: '<',
        hintKey: '<',
        labelNoFloat: '<',
        minDate: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputTime.js